import { Helmet } from "react-helmet-async";

export const SEO = ({ title, description, image, url, type = "website" }) => {
  const siteName = "Euro Cars Rent - Thessaloniki";
  const defaultDescription = "Premium car rental in Thessaloniki, Greece. Economy to luxury vehicles. Airport delivery. Competitive rates from 20/day.";
  const defaultImage = "https://images.unsplash.com/photo-1770847816156-a4041d979580?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200";

  const pageTitle = title ? `${title} | ${siteName}` : siteName;
  const pageDesc = description || defaultDescription;
  const pageImage = image || defaultImage;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
      <meta name="keywords" content="car rental, Thessaloniki, Greece, rent a car, airport transfer, SUV rental, luxury car rental, economy car rental, eurocars" />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDesc} />
      <meta property="og:image" content={pageImage} />
      {url && <meta property="og:url" content={url} />}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:locale:alternate" content="el_GR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDesc} />
      <meta name="twitter:image" content={pageImage} />

      {/* Business */}
      <meta name="geo.region" content="GR-B" />
      <meta name="geo.placename" content="Thessaloniki" />
      <meta name="geo.position" content="40.59;22.98" />
    </Helmet>
  );
};
